import React, { useEffect, useState } from 'react';
import PropTypes from "prop-types";
import withRouter from '../Components/Common/withRouter';


//import Components
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
// import RightSidebar from '../Components/Common/RightSidebar';

//import actions
import {
    changeLayout,
    changeSidebarTheme,
    changeLayoutMode,
    changeLayoutWidth,
    changeLayoutPosition,
    changeTopbarTheme,
    changeLeftsidebarSizeType,
    changeLeftsidebarViewType,
    changeSidebarImageType,
    changeSidebarVisibility
} from "../slices/thunks";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';
import AddCreatorContactModal from 'Components/creator/AddCreatorContactModal';
import AddContactMobileModal from 'Components/creator/AddContactMobileModal';
import CreatorFiltersModal from 'Components/creator/CreatorFiltersModal';
import HandleCreatorTagsModal from 'Components/creator/HandleCreatorTagsModal';
import ManageCreatorTagsOffcanvas from 'Components/creator/ManageCreatorTagsOffcanvas';
import UpdateCreatorProfileModal from 'Components/creator/UpdateCreatorProfileModal';
import { updateCreatorsFilters } from 'slices/creators/reducer';
import {
    toggleAddCreatorContactModal,
    toggleAddContactMobileModal,
    toggleAddPANModal,
    toggleCreatorFiltersModal,
    toggleHandleCreatorTagsModal,
    toggleManageCreatorTagsOffcanvas,
    toggleUpdateCreatorProfileModal,
} from 'slices/ui/reducer';
import { AppDispatch, RootState } from 'store';
import AddPANModal from 'Components/wallet/AddPANModal';


const Layout = (props: any) => {

    const dispatch = useDispatch<AppDispatch>();
    const addCreatorContactModal = useSelector((state: RootState) => state.ui.addCreatorContactModal);
    const creatorFiltersModal = useSelector((state: RootState) => state.ui.creatorFiltersModal);
    const creatorContactsFilters = useSelector((state: RootState) => state.creators.filters);
    const updateCreatorProfileModal = useSelector((state: RootState) => state.ui.updateCreatorProfileModal);
    const manageCreatorTagsOffcanvas = useSelector((state: RootState) => state.ui.manageCreatorTagsOffcanvas);
    const handleCreatorTagsModal = useSelector((state: RootState) => state.ui.handleCreatorTagsModal);
    const addContactMobileModal = useSelector((state: RootState) => state.ui.addContactMobileModal);
    const addPANModal = useSelector((state: RootState) => state.ui.addPANModal);
    const selectLayoutProperties = createSelector(
        (state: any) => state.Layout,
        (layout) => ({
            layoutType: layout.layoutType,
            leftSidebarType: layout.leftSidebarType,
            layoutModeType: layout.layoutModeType,
            layoutWidthType: layout.layoutWidthType,
            layoutPositionType: layout.layoutPositionType,
            topbarThemeType: layout.topbarThemeType,
            leftsidbarSizeType: layout.leftsidbarSizeType,
            leftSidebarViewType: layout.leftSidebarViewType,
            leftSidebarImageType: layout.leftSidebarImageType,
            preloader: layout.preloader,
            sidebarVisibilitytype: layout.sidebarVisibilitytype,
        })
    );
    // Inside your component
    const {
        layoutType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType,
        sidebarVisibilitytype
    } = useSelector(selectLayoutProperties);

    /*
    layout settings
    */
    useEffect(() => {
        if (
            layoutType ||
            leftSidebarType ||
            layoutModeType ||
            layoutWidthType ||
            layoutPositionType ||
            topbarThemeType ||
            leftsidbarSizeType ||
            leftSidebarViewType ||
            leftSidebarImageType ||
            sidebarVisibilitytype
        ) {
            window.dispatchEvent(new Event('resize'));
            dispatch(changeLeftsidebarViewType(leftSidebarViewType));
            dispatch(changeLeftsidebarSizeType(leftsidbarSizeType));
            dispatch(changeSidebarTheme(leftSidebarType));
            dispatch(changeLayoutMode(layoutModeType));
            dispatch(changeLayoutWidth(layoutWidthType));
            dispatch(changeLayoutPosition(layoutPositionType));
            dispatch(changeTopbarTheme(topbarThemeType));
            dispatch(changeLayout(layoutType));
            dispatch(changeSidebarImageType(leftSidebarImageType));
            dispatch(changeSidebarVisibility(sidebarVisibilitytype));
        }
    }, [layoutType,
        leftSidebarType,
        layoutModeType,
        layoutWidthType,
        layoutPositionType,
        topbarThemeType,
        leftsidbarSizeType,
        leftSidebarViewType,
        leftSidebarImageType,
        sidebarVisibilitytype,
        dispatch]);
    /*
    call dark/light mode
    */
    const onChangeLayoutMode = (value: any) => {
        if (changeLayoutMode) {
            dispatch(changeLayoutMode(value));
        }
    };

    const [headerClass, setHeaderClass] = useState("");
    // class add remove in header
    useEffect(() => {
        window.addEventListener("scroll", scrollNavigation, true);
    });
    function scrollNavigation() {
        var scrollup = document.documentElement.scrollTop;
        if (scrollup > 50) {
            setHeaderClass("topbar-shadow");
        } else {
            setHeaderClass("");
        }
    }

    useEffect(() => {
        const humberIcon = document.querySelector(".hamburger-icon") as HTMLElement;
        if (sidebarVisibilitytype === 'show' || layoutType === "vertical" || layoutType === "twocolumn") {
            humberIcon.classList.remove('open');
        } else {
            // humberIcon.classList.add('open');
        }
    }, [sidebarVisibilitytype, layoutType]);

    return (
        <React.Fragment>
            <div id="layout-wrapper">
                <Header
                    headerClass={headerClass}
                    layoutModeType={layoutModeType}
                    onChangeLayoutMode={onChangeLayoutMode} />
                <Sidebar layoutType={layoutType} />
                <AddCreatorContactModal isOpen={addCreatorContactModal} onClose={() => dispatch(toggleAddCreatorContactModal(false))} />
                <CreatorFiltersModal
                    isOpen={creatorFiltersModal}
                    onClose={() => dispatch(toggleCreatorFiltersModal(false))}
                    currentFilters={creatorContactsFilters}
                    onApply={(next) => dispatch(updateCreatorsFilters(next))}
                />
                <HandleCreatorTagsModal
                    isOpen={!!handleCreatorTagsModal}
                    onClose={() => dispatch(toggleHandleCreatorTagsModal(null))}
                    socialAccountId={handleCreatorTagsModal?.socialAccountId}
                    initialTags={handleCreatorTagsModal?.tags}
                    creatorName={handleCreatorTagsModal?.creatorName}
                />
                <AddContactMobileModal
                    isOpen={!!addContactMobileModal}
                    onClose={() => dispatch(toggleAddContactMobileModal(null))}
                    socialAccountId={addContactMobileModal?.socialAccountId}
                    creatorName={addContactMobileModal?.creatorName}
                />
                <UpdateCreatorProfileModal
                    isActive={!!updateCreatorProfileModal}
                    onClose={() => dispatch(toggleUpdateCreatorProfileModal(null))}
                    influencerId={updateCreatorProfileModal?.influencerId}
                    description={
                        updateCreatorProfileModal?.creatorName ? (
                            <span className="text-muted fs-13">{updateCreatorProfileModal.creatorName}</span>
                        ) : undefined
                    }
                />
                <ManageCreatorTagsOffcanvas
                    isActive={manageCreatorTagsOffcanvas}
                    onClose={() => dispatch(toggleManageCreatorTagsOffcanvas(false))}
                />
                <AddPANModal isActive={addPANModal} onClose={() => dispatch(toggleAddPANModal(false))} description={<span className="text-muted fs-12">Enter your Permanent Account Number (PAN) to start receiving earnings from campaigns.</span>} />
                <div className="main-content">{props.children}
                <Footer />
            </div>
        </div>
        {/* <RightSidebar /> */}
    </React.Fragment>

);
};
Layout.propTypes = {
    children: PropTypes.object,
};
export default withRouter(Layout);